import Head from 'next/head';
import type { NextPage } from 'next';
import { Modules } from '@/components/Modules';
import { renderMetaTags } from 'react-datocms';
import { withSession } from '@zopauk/nextjs-auth';
import { PreviewToast } from '@/components/preview/Toast';
import { useQuestionQuery } from '@/utils/dato/generated';
import { StructuredData } from '@/components/StructuredData';
import { getQuestionBreadcrumbs, buildBreadcrumbSchema } from '@/utils/breadcrumbs';
import { type QuestionModules, type QuestionContext, serverSideProps } from '@/utils/models/question';

const Question: NextPage<QuestionContext> = (context) => {
  const { data } = useQuestionQuery({ slug: context.slug });
  const breadcrumbs = data?.question ? getQuestionBreadcrumbs(data.question) : [];

  return (
    <>
      <Head>
        {data?.question?.seo ? renderMetaTags(data.question.seo.concat(data.site.favicon)) : null}
        <StructuredData structuredData={buildBreadcrumbSchema(breadcrumbs)} />
      </Head>
      {data?.template?.modular ? (
        <Modules<QuestionModules, QuestionContext> modules={data.template.modular} context={context} />
      ) : null}
      <PreviewToast />
    </>
  );
};

export const getServerSideProps = serverSideProps;

export default withSession(Question, { forceLogin: false });
